import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  analyticsApiRef,
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { costInsightsApiRef } from '@backstage/plugin-cost-insights';
import { KubecostCostInsightsClient } from './lib/cost-insights';

// import { costInsightsApiRef as logCostInsightsApiRef } from '@internal/plugin-log-cost-insights';
// import { LogCostInsightsClient } from './lib/LogCostInsightsClient';

import { exploreToolsConfigRef } from '@backstage/plugin-explore-react';
import { ExploreToolsClient } from './lib/ExploreToolsClient';

import { GoogleAnalytics } from '@backstage/plugin-analytics-module-ga';

import { techRadarApiRef } from '@backstage/plugin-tech-radar';
import { TechRadarClient } from './lib/TechRadarClient';
import { jsonRulesEngineCheckResultRenderer, techInsightsApiRef, TechInsightsClient } from '@backstage/plugin-tech-insights';
import { otkRenderer } from './components/OtkRender';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),

  createApiFactory({
    api: analyticsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => GoogleAnalytics.fromConfig(configApi),
  }),

  createApiFactory({
    api: costInsightsApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      identityApi: identityApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, identityApi, configApi }) => {
      return new KubecostCostInsightsClient({
        discoveryApi,
        identityApi,
        configApi
      });
    },
  }),

  createApiFactory({
    api: techInsightsApiRef,
    deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
    factory: ({ discoveryApi, identityApi }) =>
      new TechInsightsClient({
        discoveryApi,
        identityApi,
        renderers: [
          otkRenderer,
        ],
      }),
  }),

//  createApiFactory({
//    api: logCostInsightsApiRef,
//    deps: {
//      discoveryApi: discoveryApiRef,
//      identityApi: identityApiRef,
//      configApi: configApiRef,
//    },
//    factory: ({ discoveryApi, identityApi, configApi }) => {
//      return new LogCostInsightsClient({
//        discoveryApi: discoveryApi,
//        identityApi: identityApi,
//      });
//    },
//  }),

  createApiFactory(exploreToolsConfigRef, new ExploreToolsClient()),

  createApiFactory(techRadarApiRef, new TechRadarClient()),

  ScmAuth.createDefaultApiFactory(),
];
